// 做为一个vue插件 对router简体路由切换的事件来上报pvuv,埋点统计，错误捕获上报
import { reportStatistics, reportLog } from './report';
var pageInitTimeMap = {};
var pvHandle;
function routerPluginInit(app) {
    if (app.config.globalProperties.$router) {
        var curRouter = app.config.globalProperties.$router;
        curRouter.beforeEach(function (to, from, next) {
            var nowTime = Date.now();
            pageInitTimeMap[to.path] = nowTime;
            if (to && from && from.path !== to.path && pageInitTimeMap[from.path]) {
                var pageTime = nowTime - pageInitTimeMap[from.path];
                reportStatistics([
                    {
                        evtName: 'pageTime',
                        hash: from.fullPath,
                        extraMsg: 'destroy',
                        num: "".concat(pageTime),
                    },
                ]);
            }
            if (pvHandle) {
                clearTimeout(pvHandle);
            }
            pvHandle = setTimeout(function () {
                reportStatistics([
                    {
                        evtName: 'pv',
                        hash: to.fullPath,
                        extraMsg: "fromPath:".concat(from.path || ''),
                    },
                ]);
            }, 200);
            next();
        });
    }
    else {
        if (pvHandle) {
            clearTimeout(pvHandle);
        }
        // 单页面 没用router
        pvHandle = setTimeout(function () {
            reportStatistics([
                {
                    evtName: 'pv',
                },
            ]);
        }, 200);
    }
}
function statDirective(app) {
    app.directive('stat', {
        beforeMount: function (el, binding) {
            var urlObj = new URL(window.location.href);
            var hash = urlObj.hash ? urlObj.hash.substr(1) : '';
            el.addEventListener('click', function () {
                var targetVal = binding.value;
                if (typeof targetVal === 'object') {
                    // 如果是object 那么格式必须是 {event:'xxxxx',num:'123'} 代表 某个事件id上报的数量不是1  而是 num里面的数字 否则为1
                    reportStatistics([
                        {
                            evtName: targetVal.event,
                            num: targetVal.num || '1',
                            hash: hash,
                        },
                    ]);
                }
                else {
                    reportStatistics([
                        {
                            evtName: targetVal,
                            num: '1',
                            hash: hash,
                        },
                    ]);
                }
            }, false);
        },
    });
}
function onErrorCapture(app) {
    app.config.errorHandler = function (err, vm, info) {
        var _a, _b;
        var error = err;
        var tmp = Object.assign({}, vm);
        // @ts-ignore
        delete tmp.$i18n;
        reportLog({
            msg: (error === null || error === void 0 ? void 0 : error.message) || '',
            stack: (error === null || error === void 0 ? void 0 : error.stack) || '',
            ext1: JSON.stringify(tmp),
            // @ts-ignore
            errMsg: "\u7EC4\u4EF6\uFF1A".concat((_b = (_a = vm === null || vm === void 0 ? void 0 : vm.$.vnode) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.__file, " \u53D1\u751F\u9519\u8BEF\uFF1A").concat(err, " , \u6240\u5728\u751F\u547D\u5468\u671F\uFF1A").concat(info),
        });
        throw err;
    };
}
var statPlugin = {
    install: function (app) {
        // 路由切换上报
        routerPluginInit(app);
        // 埋点指令植入
        statDirective(app);
        // 错误捕获上报
        onErrorCapture(app);
    },
};
export { statPlugin };
